var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ENVIRONMENT, GTM_ID, IS_DEMO } from '@web/config';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
var GTM_ENVIRONMENT = IS_DEMO ? 'demo' : ENVIRONMENT;
export var trackPageView = function (path) {
    if (!GTM_ID || !window.dataLayer) {
        return;
    }
    window.dataLayer.push({
        event: 'page_view',
        page_path: path,
        page_title: document.title
    });
};
export var pushEvent = function (eventName, eventData) {
    if (!GTM_ID || !window.dataLayer) {
        return;
    }
    window.dataLayer.push(__assign({ event: eventName }, eventData));
};
export var GTM = function () {
    useEffect(function () {
        if (!GTM_ID) {
            return;
        }
        var existingNoscript = document.querySelector("noscript iframe[src*=\"googletagmanager.com/ns.html?id=".concat(GTM_ID, "\"]"));
        if (!existingNoscript) {
            var noscript = document.createElement('noscript');
            var iframe = document.createElement('iframe');
            iframe.src = "https://www.googletagmanager.com/ns.html?id=".concat(GTM_ID);
            iframe.height = '0';
            iframe.width = '0';
            iframe.style.display = 'none';
            iframe.style.visibility = 'hidden';
            noscript.appendChild(iframe);
            document.body.insertBefore(noscript, document.body.firstChild);
        }
    }, []);
    if (!GTM_ID) {
        return null;
    }
    var gtmScript = "window.dataLayer=window.dataLayer||[];window.dataLayer.push({environment:'".concat(GTM_ENVIRONMENT, "'});\n(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','").concat(GTM_ID, "');");
    return (_jsx(Helmet, { children: _jsx("script", { children: gtmScript }) }));
};
export var useGTMPageTracking = function () {
    var location = useLocation();
    useEffect(function () {
        trackPageView(location.pathname + location.search);
    }, [location.pathname, location.search]);
};
